import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MAIN_MENU } from 'src/app/app-constants';
import { OrgAction } from 'src/app/dashboard/stores/org';

@Injectable({ providedIn: 'root' })
export class MainMenuComponentResolver implements Resolve<any> {
    constructor(private store: Store) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | any {
        return this.store.dispatch(new OrgAction.Self()).pipe(
            tap(() => {
                // NGXS v20: dispatch returns Observable<void>, get state via selectSnapshot
                const orgState = this.store.selectSnapshot((state: any) => state.org);
                if (orgState?.org?.IsWaiter) {
                    this.store.dispatch(new Navigate(MAIN_MENU.pos.link));
                }
            })
        );
    }
}
